import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from '../icons/SalesIcons';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Antes de este curso había intentado tres veces hacer velas y siempre me salían con huecos. Desde el módulo 6 entendí todo. Ahora vendo cada semana.',
    author: 'Alumna activa del curso'
  }, {
    quote: 'La tabla de pabilos sola ya valió cada peso que pagué. Nunca más elegí mal.',
    author: 'Alumna activa del curso'
  }, {
    quote: 'Stefany explica de una forma que parece que estás con ella en persona. Se nota que le apasiona enseñar.',
    author: 'Alumna activa del curso'
  }];
  return <section className="bg-[#FFFAF5] py-16 md:py-24" data-id="element-385">
      <div className="max-w-6xl mx-auto px-4" data-id="element-386">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-387">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#5C4033] mb-4" data-id="element-388">
            Lo Que Dicen Nuestras Alumnas
          </h2>
          <p className="text-xl text-[#2D2926]" data-id="element-389">
            Historias reales de transformación
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8" data-id="element-390">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-2xl shadow-xl border border-[#C4A882]/30 p-8 relative" data-id="element-391">
              {/* Quote Icon */}
              <div className="absolute -top-4 left-8" data-id="element-392">
                <div className="w-10 h-10 rounded-full bg-[#9B2335] flex items-center justify-center" data-id="element-393">
                  <QuoteIcon size={20} className="text-white" data-id="element-394" />
                </div>
              </div>

              {/* Stars */}
              <div className="flex items-center gap-1 mb-4 pt-4" data-id="element-395">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} className="text-[#C4A882]" data-id="element-396" />)}
              </div>

              {/* Quote */}
              <p className="text-[#2D2926] leading-relaxed mb-6 italic" data-id="element-397">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="border-t border-[#C4A882]/30 pt-4" data-id="element-398">
                <p className="font-bold text-[#5C4033]" data-id="element-399">{testimonial.author}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}